import React from 'react';
import Header from '../base/Header';

const AdminHeader = ({ onMenuToggle }) => {
  const menuItems = [
    { label: '代理店検索', path: '/admin/agency/search' },
    { label: 'アカウント設定', path: '/admin/account/list' },
    { label: '登録保険会社申請一覧', path: '/admin/insurance/applications' },
    { label: 'おしらせ管理', path: '/admin/notices' }
  ];
  return (
    <Header onMenuToggle={onMenuToggle} menuItems={menuItems}/>
  );
};

export default AdminHeader;